import React, { useState, useEffect } from 'react';
import { Card, Form, Alert, Dropdown, Button } from 'react-bootstrap';
import { HHIEButton } from '../../utility/HHIEButton';
import { HHIECard } from '../../utility/HHIECard';
import { HHIEError } from '../../utility/HHIEError';
import Loading from '../../utility/Loading';
import { returnPOCUserObject } from '../../utility/returnPOCUserObject';

export function SetSecurityQuestions() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);

    const [pocid, setPocid] = useState();
    const [requiredQuestionCount, setRequiredQuestionCount] = useState(0);
    const [questions, setQuestions] = useState(null);
    const [dropdownQuestions, setDropdownQuestions] = useState(null);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);

    useEffect(() => {
        try {
            const user = JSON.parse(sessionStorage.getItem("user"));
            if (user === null) {
                setError(true);
                setErrorMessage("You must be associated with an account for this portion.");
                setTimeout(() => { window.location.href = '/' }, 3000);
                return;
            }
            if (user.securityQuestionsComplete) {
                setError(true);
                setErrorMessage("You have completed your security questions already. Please contact the HHIE if you would like to change this information.");
                if (user.passwordIsTemporary) {
                    setTimeout(() => { window.location.href = '/reset-temp-password' }, 3000);
                }
                else {
                    setTimeout(() => { window.location.href = '/login' }, 3000);
                    return;
                }
            }
            // SET POCID
            setPocid(user.pocid);

            // SET REQUIRED QUESTION COUNT
            fetch('/api/admin/GetRequiredQuestionCount')
                .then(response => response.json())
                .then(json => {
                    if (json.errors !== null && json.errors !== "") alert(json.errors)
                    setRequiredQuestionCount(json.message)
                })
                .catch(error => console.log("GetRequiredQuestionCount error: ",error));

            // SET QUESTIONS and DROPDOWN Q's menu 
            fetch('/api/admin/getQuestions/' + user.sfid)
                .then(response => response.json())
                .then(json => {
                    if (json.errors !== null && json.errors !== "") alert(json.errors)
                    setQuestions(json.message);
                    setDropdownQuestions(json.message);
                })
                .catch(error => console.log("retrieve questions error: ", error));

            setLoading(false);
        }
        catch (ex) {
            console.log(ex);
        }

    }, []);

    const handleAnswer = (value, qid) => {
        let answersState = [...answers];
        let answerObj = { pocId: pocid, resetQuestionId: qid, value: value }
        let index = answersState.findIndex(answer => {
            return answer.resetQuestionId === qid;
        });
        if (index < 0) {
            answersState.push(answerObj);
        } else {
            answersState[index] = answerObj;
        }
        setAnswers(answersState);

    }
    
    const handleSubmit = async () => {

        let index = answers.findIndex((answer) => { return answer.value === '' });
        if (answers.length < requiredQuestionCount || index !== -1) {
            setError(true);
            setErrorMessage("Must answer all questions to submit.");
            return;
        }
        const requestOptions = {
            method: "POST",
            body: JSON.stringify(answers),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        const pocObject = await fetch('api/POCUser/save-question-answers', requestOptions)
            .then(async (response) => {
                if (response.status === 204) {
                    return null;
                }
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                } catch (ex) {
                    console.log(ex);
                    return null;
                }
            })
            .catch((error) => { 
                console.log("text error: ", error); 
            }
        );
        if (pocObject !== null) {
            setSuccess(true);
            const pocUser = returnPOCUserObject(pocObject);
            sessionStorage.removeItem("user");
            sessionStorage.setItem("user", JSON.stringify(pocUser));
            var location = "/reset-temp-password";
            if (!pocUser.passwordIsTemporary) {
                location = "/registration-dashboard";
            }
            setTimeout(() => { window.location.href = location; }, 3000);
        } else {
            setError(true);
            setErrorMessage("Questions weren't saved!");
        }
    }

    const resetChoices = () => {
        setSelectedQuestions([]);
        setAnswers([]);
        return;
    }
    function renderQuestionForm() {
        let formGroups = selectedQuestions.map((question) => {
            return (
                <Form.Group key={question.id}>
                    <Form.Label>{question.value}</Form.Label>
                    <Form.Control
                        type="text"
                        onChange={(e) => {
                            handleAnswer(e.target.value, question.id);
                        }}
                    />
                </Form.Group>
            );
        });
        return (
            <>
                <HHIEButton
                    id="reset-btn"
                    title="Reset Choices"
                    variant="warning"
                    size="sm"
                    style={{}}
                    onClick={resetChoices}
                />
                <Form>
                    {formGroups}
                    <HHIEButton
                        id="submit-btn"
                        title="Submit Answers"
                        disabled={selectedQuestions.length !== requiredQuestionCount}
                        onClick={handleSubmit}
                    />
                </Form>
            </>
        );
    }

    const handleSelect = (qid) => {
        const id = parseInt(qid);
        if (selectedQuestions.findIndex(q => { return q.id === qid; }) !== -1) {
            setError(true);
            setErrorMessage("This has already been selected.");
            return;
        }
        for (var i = 0; i < questions.length; i++) {
            if (questions[i].id === id) {

                let newState = [...selectedQuestions];
                newState.push(questions[i]);
                setSelectedQuestions(newState);
                break;
            }
        }
    }
    function renderDropdownMenu() {
        let items = dropdownQuestions.map(question => {
            let qDisabled = selectedQuestions.includes(question);
            let limitReached = (selectedQuestions.length >= requiredQuestionCount);
            return (
                <Dropdown.Item
                    key={question.id}
                    eventKey={question.id}
                    value={question.id}
                    disabled={qDisabled || limitReached}
                //style={{borderColor: (disabled) ? 'green': ''}}
                >
                    {question.value}
                </Dropdown.Item>
            );
        });
        return (
            <>
                <Dropdown
                    onSelect={
                        (e) => { handleSelect(e) }
                    }
                >
                    <Dropdown.Toggle variant="secondary" style={{ marginTop: "4px" }}>
                        Please choose {requiredQuestionCount - selectedQuestions.length} questions to answer.
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {items}
                    </Dropdown.Menu>
                </Dropdown>
                <hr />
            </>
        );
    }
    // PAGE RENDER ret
    return (
        <HHIECard>
            {!success &&
            <>
                <Card.Text>
                    HHIE requires its users to answer {requiredQuestionCount} security
                    questions to securely recover an account in the event of a forgotten password.
                </Card.Text>
                
                {loading && <Loading message={<div>Loading. . . please wait</div>} />}
                {dropdownQuestions && renderDropdownMenu()}
                {selectedQuestions.length > 0
                    ? renderQuestionForm()
                    : <em>selected questions go here.</em>
                }
            </>
            }
            {error &&
                <HHIEError message={errorMsg} onClick={() => { setError(false); setErrorMessage(""); }}/>
            }
            {success && <Alert variant="success">Success! Redirecting you . . .</Alert>}
        </HHIECard>
    );
}
